import {
  pythonClient,
  openAiClient,
} from "../config/axios";
// import * as Sentry from "@sentry/react";
export const fetchChatGPT = async (params) => {
  // let parsedUser = null;
  let teacher_id = null;
  const localStorageUser = localStorage.getItem("user");
  if (localStorageUser) {
    const parsedUser = JSON.parse(localStorageUser);
    teacher_id = parsedUser.id;
  }
  const data = { ...params, teacher_id };
  try {
    const response = await pythonClient.post("/chatgpt", { ...data });
    return response.data;
  } catch (error) {
    // const errorMessage = `ChatGPT Legacy Service Error`;
    // Sentry.captureMessage(errorMessage, 'error');
    // Sentry.withScope((scope) => {
    //   scope.setTag("service_location", "chatService_fetchChatGPT");
    //   scope.setLevel("error");
    //   scope.setExtra("payload", data); // Optional: Add additional context
    //   if (localStorageUser) {
    //     scope.setUser({
    //       id: parsedUser?.id,
    //       email: parsedUser?.email,
    //       first_name: parsedUser?.first_name,
    //       last_name: parsedUser?.last_name,
    //     });
    //   }
    //   Sentry.captureException(error);
    // });
    throw error;
  }
};

export const fetchAssistantChatGPT = async (params) => {
  let parsedUser = null;
  let teacher_id = null;
  const localStorageUser = localStorage.getItem("user");
  if (localStorageUser) {
    parsedUser = JSON.parse(localStorageUser);
    teacher_id = parsedUser.id;
  }
  const data = { ...params, teacher_id };
  try {
    const response = await openAiClient.post("/interactions", { ...data });
    return response.data;
  } catch (error) {
    throw error;
  }
};


/**
 * Funcion que extrae las opciones de un texto
 * @param {*} text 
 * @param {*} patterns 
 * @returns 
 */
export function extractOptions(text, patterns = [/<validatedgoal>(.*?)<\/validatedgoal>/gs, /<option>(.*?)<\/option>/gs]) {

  if (!patterns?.length) return text;
  const matches = [...text.matchAll(patterns[0])];

  const result = matches.map(match => {
    return extractOptions(match[1].trim(), patterns.slice(1));
  });
  return result;
}

/**
 * Funcion que limpia el markdown de un texto de los llm
 * @param {*} text 
 * @returns 
 */
export const clearMarkdown = (text) => {
  const rules = [
    { regex: /^(#{1,6})\s*(.*)$/gm, replacement: '$2' }, // Headers
    // eslint-disable-next-line
    { regex: /^\s*[\*\-\+]\s+/gm, replacement: '' }, // Lists
    // eslint-disable-next-line
    { regex: /\[([^\]]+)\]\([^\)]+\)/g, replacement: '$1' }, // Links
    // eslint-disable-next-line
    { regex: /(\*\*|__)(.*?)\1/g, replacement: '$2' }, // Bold
    { regex: /(\*|_)(.*?)\1/g, replacement: '$2' }, // Italics
    // eslint-disable-next-line
    { regex: /!\[([^\]]+)\]\([^\)]+\)/g, replacement: '' }, // Images
    { regex: /`([^`]+)`/g, replacement: '$1' }, // Inline code
    { regex: /```[\s\S]*?```/g, replacement: '' }, // Code blocks
    { regex: /(\|.*\|)/g, replacement: '' }, // Tables
    { regex: /\n+/g, replacement: ' ' } // Extra line breaks
  ];

  rules.forEach(rule => {
    text = text.replace(rule.regex, rule.replacement);
  });

  return text.trim();
};

